import React from 'react';

import { AppointmentType } from 'src/services/availability';
import {
    ExpressTelehealthPurpose,
    expressTelehealthPurpose,
    isExpressTelehealth,
    newPatientRegex,
} from 'src/utils/appointmentTypes';

type Props = {
    appointmentType: AppointmentType;
};

function expressTelehealthDescription(appointment: AppointmentType): string {
    switch (expressTelehealthPurpose(appointment)) {
        case ExpressTelehealthPurpose.Script:
            return 'Renew ongoing long-term medications';
        case ExpressTelehealthPurpose.MedicalCertificate:
            return "Sick/Carer's certificate for minor non-serious illnesses";
        case ExpressTelehealthPurpose.Referral:
            return 'Renew or update ongoing referrals for specialists/allied health';
        case ExpressTelehealthPurpose.Diagnostics:
            return 'Forms for Bloods Tests and Scans for existing, ongoing issues';
        case ExpressTelehealthPurpose.Unknown:
        default:
            return '';
    }
}

export function AppointmentTypeOption({ appointmentType }: Props) {
    if (isExpressTelehealth(appointmentType)) {
        return (
            <div className="flex h-full min-h-6 flex-col justify-center" title={appointmentType.appointmentName}>
                <p className="overflow-hidden text-ellipsis text-sm font-medium text-gray-900">
                    {appointmentType.appointmentName.replace(newPatientRegex, '')}
                </p>
                <p className="text-xs font-normal text-gray-600">{expressTelehealthDescription(appointmentType)}</p>
            </div>
        );
    }

    return (
        <div
            className="flex h-full min-h-6 flex-col justify-center gap-1 md:gap-2"
            title={appointmentType.appointmentName}
        >
            <p className="overflow-hidden text-ellipsis text-sm font-medium text-gray-900">
                {appointmentType.appointmentName.replace(newPatientRegex, '')}
            </p>
        </div>
    );
}
